import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import SaveIcon from '@material-ui/icons/Save';
import EyeIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import ResetIcon from '@material-ui/icons/DeleteSweep';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {ToastContainer} from 'react-toastify';
import {observer} from "mobx-react";
import moment from 'moment'
import 'moment-timezone';
import QRCode from 'qrcode.react';
import environment from '../environments';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../assets/css/react-datepicker.css";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 220
    },
    textFieldMultiline: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 400
    },
    paper: {
        padding: 5,
        margin: 5
    },
    editor: {
        border: '1px solid gray',
        minHeight: '6em'
    },
    appBar: {
        backgroundColor: 'white',
        top: 'auto',
        bottom: 0,
    }
});

class StickerDetails extends Component
{

    constructor(props)
    {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLandingpageInputChange = this.handleLandingpageInputChange.bind(this);
        this.handleResetSticker = this.handleResetSticker.bind(this);
        this.toggleSaveModal = this.toggleSaveModal.bind(this);
        this.handleSafetySaveCheckInputChange = this.handleSafetySaveCheckInputChange.bind(this);
        this.toggleResetModal = this.toggleResetModal.bind(this);
        this.handleSafetyResetCheckInputChange = this.handleSafetyResetCheckInputChange.bind(this);

        this.state = {
            saveModal: false,
            resetModal: false,
            safetySaveCheckWord: '',
            safetySaveCheckPassed: false,
            safetyResetCheckWord: '',
            safetyResetCheckPassed: false
        }
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.props.stickerStore.sticker[name] = value;
    }

    handleLandingpageInputChange(event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let newLandingpageValues = this.props.stickerStore.sticker.landingpageValues.map(function (item)
        {
            if (item.uuid === name)
            {
                item.inputvalue = value
            }
            return item
        })
        this.props.stickerStore.sticker.landingpageValues = newLandingpageValues;
    }

    handleLandingpageDateTimeChange(dateTime, uuid)
    {
        let newLandingpageValues = this.props.stickerStore.sticker.landingpageValues.map(function (item)
        {
            if (item.uuid === uuid)
            {
                item.inputvalue = moment(dateTime).toISOString()
            }
            return item
        })
        this.props.stickerStore.sticker.landingpageValues = newLandingpageValues;
    }

    handleSaveSticker(event)
    {
        this.props.stickerStore.saveSticker(this.props.match.params.id);
        this.toggleSaveModal();
    }

    handleResetSticker(event)
    {
        this.props.stickerStore.resetSticker(this.props.match.params.id);
        this.toggleResetModal();
    }

    toggleSaveModal()
    {
        this.setState({
            saveModal: !this.state.saveModal,
        });
    }

    toggleResetModal()
    {
        this.setState({
            resetModal: !this.state.resetModal,
        });
    }

    handleSafetySaveCheckInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.setState({safetySaveCheckWord: value})
        if (value === this.props.stickerStore.sticker.identifier)
        {
            this.setState({safetySaveCheckPassed: true})
        } else
        {
            this.setState({safetySaveCheckPassed: false})
        }
    }

    handleSafetyResetCheckInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.setState({safetyResetCheckWord: value})
        if (value === this.props.stickerStore.sticker.identifier)
        {
            this.setState({safetyResetCheckPassed: true})
        } else
        {
            this.setState({safetyResetCheckPassed: false})
        }
    }

    componentDidMount()
    {
        this.props.stickerStore.getSticker(this.props.match.params.id);
        /* this.props.stickerStore.getStickerPhotos(this.props.match.params.id); */
    }

    render()
    {
        const {classes} = this.props;

        return (
            <div>
                <ToastContainer/>
                <Dialog
                    open={this.state.saveModal}
                    onClose={this.toggleSaveModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Sticker speichern</DialogTitle>
                    <DialogContent>
                        <span style={{color: 'red'}}>Die Veränderungen von Daten eines Stickers werden auch für den Besitzer sichtbar und <b>können Beschwerden nach sich ziehen</b></span><br/><br/>
                        Um die Daten des Stickers <strong>{this.props.stickerStore.sticker.identifier}</strong> wirklich zu verändern, bestätige den Vorgang
                        durch Eingabe der Sticker-ID <strong>{this.props.stickerStore.sticker.identifier}</strong>.
                        <br/>
                        <TextField
                            id="identifier"
                            name="identifier"
                            label="Sticker-ID"
                            className={classes.textField}
                            value={this.state.safetySaveCheckWord}
                            onChange={this.handleSafetySaveCheckInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                            fullWidth={true}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleSaveModal} className={classes.button}>
                            <CancelIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.handleSaveSticker()} className={classes.warningButton}
                                disabled={!this.state.safetySaveCheckPassed}>
                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Speichern
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.resetModal}
                    onClose={this.toggleResetModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Sticker zurücksetzen</DialogTitle>
                    <DialogContent>
                        <span style={{color: 'red'}}>Durch das Zurücksetzen des Stickers <b>werden sämtliche Daten gelöscht und der Sticker wird aus dem Benutzerkonto des Besitzers entfernt.</b><b>Diese Änderung kann nicht rückgängig gemacht werden!</b></span><br/><br/>
                        Um den Sticker <strong>{this.props.stickerStore.sticker.identifier}</strong> wirklich zurückzusetzen, bestätige den Vorgang durch
                        Eingabe der Sticker-ID <strong>{this.props.stickerStore.sticker.identifier}</strong>.
                        <br/>
                        <TextField
                            id="identifier"
                            name="identifier"
                            label="Sticker-ID"
                            className={classes.textField}
                            value={this.state.safetyResetCheckWord}
                            onChange={this.handleSafetyResetCheckInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                            fullWidth={true}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleResetModal} className={classes.button}>
                            <CancelIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.handleResetSticker()} className={classes.warningButton}
                                disabled={!this.state.safetyResetCheckPassed}>
                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Zurücksetzen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Typography variant="title" gutterBottom>
                    Sticker: {this.props.stickerStore.sticker.identifier}
                </Typography>
                <form noValidate autoComplete="off">
                    <Grid container spacing={16} style={{marginBottom: 30}} alignItems="center">
                        <Grid item>
                            <Paper className={classes.paper}>
                                <QRCode value={environment.DELIVERY_HOST + "/" + this.props.stickerStore.sticker.identifier + "?preview=1"}/>
                            </Paper>
                            <Grid item style={{textAlign: 'center'}}>
                                <Button variant="contained" size="small" color="primary"
                                        onClick={() => window.open(environment.DELIVERY_HOST + "/" + this.props.stickerStore.sticker.identifier + "?preview=1",
                                            "_blank")} className={classes.button}>
                                    <EyeIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                    Vorschau
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <TextField
                                id="name"
                                name="name"
                                label="Produkt"
                                className={classes.textField}
                                value={this.props.stickerStore.sticker.name || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                                onClick={() => this.props.history.push("/products/" + this.props.stickerStore.sticker.products_uuid)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <img width="32" height="32" src={this.props.stickerStore.sticker.icon_key ?
                                                environment.CDN_HOST + "/" + this.props.stickerStore.sticker.icon_key :
                                                require("../assets/img/banner-placeholder.png")} alt="Small Icon"/>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <br/>
                            <TextField
                                id="user_id"
                                name="user_id"
                                label="Stickerinhaber"
                                className={classes.textField}
                                value={this.props.stickerStore.sticker.user_id || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                onClick={() =>
                                {
                                    (this.props.stickerStore.sticker.user_id && this.props.stickerStore.sticker.user_id !== '') ?
                                        this.props.history.push("/users/" + this.props.stickerStore.sticker.user_id) : alert("Keine gültige Benutzerkennung")
                                }}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="scans"
                                name="scans"
                                label="Anzahl Scans"
                                className={classes.textField}
                                value={this.props.stickerStore.sticker.scans || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="active"
                                name="active"
                                select
                                label="Sticker aktiv"
                                className={classes.textField}
                                value={String(+this.props.stickerStore.sticker.active)}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                            <br/>
                            <TextField
                                id="title"
                                name="title"
                                label="Stickername"
                                className={classes.textField}
                                value={this.props.stickerStore.sticker.title || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="url"
                                name="url"
                                label="URL"
                                className={classes.textField}
                                value={this.props.stickerStore.sticker.url || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="created"
                                label="Erstellt"
                                className={classes.textField}
                                value={this.props.stickerStore.sticker.created ? moment(this.props.stickerStore.sticker.created).format("DD.MM.YYYY / HH:mm") :
                                    'Nie'}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="updated"
                                label="Zuletzt bearbeitet"
                                className={classes.textField}
                                value={this.props.stickerStore.sticker.updated ? moment(this.props.stickerStore.sticker.updated).format("DD.MM.YYYY / HH:mm") :
                                    'Nie'}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="granted"
                                label="Aktiviert"
                                className={classes.textField}
                                value={this.props.stickerStore.sticker.granted ? moment(this.props.stickerStore.sticker.granted).format("DD.MM.YYYY / HH:mm") :
                                    'Nie'}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                    </Grid>
                    <hr/>
                    <Typography variant="subheading" gutterBottom>
                        Infoseite
                    </Typography>
                    <Grid container spacing={16} style={{marginBottom: "50px"}}>
                        <Grid item>
                            <TextField
                                id="lp_active"
                                name="lp_active"
                                select
                                label="Infoseite aktiv"
                                className={classes.textField}
                                value={String(+this.props.stickerStore.sticker.lp_active)}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                            <br/>
                            <TextField
                                id="tracking_active"
                                name="tracking_active"
                                select
                                label="Tracking aktiv"
                                className={classes.textField}
                                value={String(+this.props.stickerStore.sticker.tracking_active)}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                disabled={!(!!this.props.stickerStore.sticker.lp_active)}
                                InputLabelProps={{shrink: true}}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                        <Grid item>
                            {this.props.stickerStore.sticker.landingpageInputs.map(function (item, index)
                            {
                                switch (item.type)
                                {
                                    case 'text':
                                        return (
                                            <TextField
                                                id={item.uuid}
                                                key={item.uuid}
                                                name={item.uuid}
                                                label={item.label}
                                                placeholder={item.placeholder}
                                                type="text"
                                                className={classes.textField}
                                                value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                                                onChange={this.handleLandingpageInputChange}
                                                margin="normal"
                                                InputLabelProps={{shrink: true}}
                                            />
                                        )
                                    case 'text-multiline':
                                        return (
                                            <TextField
                                                id={item.uuid}
                                                key={item.uuid}
                                                name={item.uuid}
                                                label={item.label}
                                                placeholder={item.placeholder}
                                                type="text"
                                                multiline
                                                className={classes.textField}
                                                value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                                                onChange={this.handleLandingpageInputChange}
                                                margin="normal"
                                                InputLabelProps={{shrink: true}}
                                            />
                                        )
                                    case 'number':
                                        return (
                                            <TextField
                                                id={item.uuid}
                                                key={item.uuid}
                                                name={item.uuid}
                                                label={item.label}
                                                placeholder={item.placeholder}
                                                type="number"
                                                className={classes.textField}
                                                value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                                                onChange={this.handleLandingpageInputChange}
                                                margin="normal"
                                                InputLabelProps={{shrink: true}}
                                            />
                                        )
                                    case 'email':
                                        return (
                                            <TextField
                                                id={item.uuid}
                                                key={item.uuid}
                                                name={item.uuid}
                                                label={item.label}
                                                placeholder={item.placeholder}
                                                type="email"
                                                className={classes.textField}
                                                value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                                                onChange={this.handleLandingpageInputChange}
                                                margin="normal"
                                                InputLabelProps={{shrink: true}}
                                            />
                                        )
                                    case 'phone':
                                        return (
                                            <TextField
                                                id={item.uuid}
                                                key={item.uuid}
                                                name={item.uuid}
                                                label={item.label}
                                                placeholder={item.placeholder}
                                                type="number"
                                                className={classes.textField}
                                                value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                                                onChange={this.handleLandingpageInputChange}
                                                margin="normal"
                                                InputLabelProps={{shrink: true}}
                                            />
                                        )
                                    case 'editor':
                                        return <div key={item.uuid}>Editor</div>;
                                    case 'dropdown':
                                        return (
                                            <TextField
                                                id={item.uuid}
                                                key={item.uuid}
                                                name={item.uuid}
                                                label={item.label}
                                                placeholder={item.placeholder}
                                                className={classes.textField}
                                                value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ""}
                                                onChange={this.handleLandingpageInputChange}
                                                margin="normal"
                                                InputLabelProps={{shrink: true}}
                                                select
                                                SelectProps={{
                                                    native: true,
                                                    MenuProps: {
                                                        className: classes.menu,
                                                    },
                                                }}>
                                                {(item.options !== null) ? (
                                                    JSON.parse(item.options).map(function (item, index)
                                                    {
                                                        return <option value={item} key={index}>{item}</option>
                                                    })
                                                ) : (
                                                    <option disabled>-</option>
                                                )}
                                            </TextField>
                                        )
                                    case 'options':
                                        return null
                                    case 'date':
                                        return (
                                            <DatePicker
                                                key={item.uuid}
                                                selected={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue ?
                                                    new Date(
                                                        this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue) :
                                                    null}
                                                onChange={(event) => this.handleLandingpageDateTimeChange(event, item.uuid)}
                                                dateFormat="dd.MM.yyyy"
                                                customInput={<TextField
                                                    fullWidth={true}
                                                    label={item.label}
                                                    placeholder={item.placeholder}
                                                    className={classes.textField}
                                                    margin="normal"
                                                    InputLabelProps={{shrink: true}}/>}
                                            />
                                        )
                                    case 'time':
                                        return (
                                            <DatePicker
                                                key={item.uuid}
                                                selected={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue ?
                                                    new Date(
                                                        this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue) :
                                                    null}
                                                onChange={(event) => this.handleLandingpageDateTimeChange(event, item.uuid)}
                                                timeCaption={item.label}
                                                timeFormat="HH:mm"
                                                dateFormat="HH:mm"
                                                showTimeSelect
                                                showTimeSelectOnly
                                                customInput={<TextField
                                                    fullWidth={true}
                                                    label={item.label}
                                                    placeholder={item.placeholder}
                                                    className={classes.textField}
                                                    margin="normal"
                                                    InputLabelProps={{shrink: true}}/>}
                                            />
                                        )
                                    case 'layout':
                                        switch (item.html_element)
                                        {
                                            case 'span':
                                                return (<Typography key={item.uuid}>{item.label}</Typography>)
                                            case 'h1':
                                            case 'h2':
                                            case 'h3':
                                            case 'h4':
                                            case 'h5':
                                            case 'h6':
                                                return (<Typography key={item.uuid} variant="h6"
                                                                    style={{marginTop: "20px", fontSize: "1.10rem"}}>{item.label}</Typography>)
                                            default:
                                                return null
                                        }
                                    default:
                                        return <div key={item.uuid}>Default</div>;
                                }
                            }, this)}
                        </Grid>
                    </Grid>
                    <AppBar position="fixed" color="primary" className={classes.appBar}>
                        <Toolbar>
                            <Grid
                                container
                                direction="row"
                                justify="flex-end"
                                alignItems="flex-start">
                                <Grid item>
                                    <Button variant="contained" size="small" color="default" onClick={() => this.toggleResetModal()} className={classes.button}>
                                        <ResetIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Zurücksetzen
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" size="small" color="secondary" onClick={() => this.toggleSaveModal()}
                                            className={classes.button}>
                                        <SaveIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Speichern
                                    </Button>
                                </Grid>
                            </Grid>
                            <div className={classes.grow}/>
                        </Toolbar>
                    </AppBar>
                </form>
            </div>
        );
    }
}

export default withStyles(styles)(observer(StickerDetails));
